import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, createStaticVNode as i, openBlock as a } from "vue";
//#region ../src/illustrations/mind.vue
var o = {
	name: "DtIllustrationMind",
	props: { ariaLabel: {
		type: String,
		default: void 0
	} },
	emits: ["loaded"],
	computed: {
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-illustration";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], c = ["fill"], l = ["fill"], u = ["id"], d = ["id"], f = ["id"], p = ["id"], m = ["id"], h = ["id"], g = ["id"], _ = ["id"], v = ["id"], y = ["id"], b = ["id"], x = ["id"], S = ["id"], C = ["id"];
function w(e, t, o, w, T, E) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		"data-qa": E.dataQA,
		"aria-hidden": E.ariaHidden,
		focusable: "false",
		role: "img",
		"data-name": "Mind",
		class: "d-illustration d-illustration--mind",
		width: "200",
		height: "200",
		viewBox: "0 0 200 200",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg"
	}, [
		r("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M24.9999 105.801L173.862 105.801C173.24 140.686 140.154 168.801 99.4308 168.801C58.7073 168.801 25.6215 140.686 24.9999 105.801Z",
			fill: `url(#${e.uniqueID}paint0_linear_14_817694)`
		}, null, 8, c),
		t[14] || (t[14] = i("<path d=\"M25.5125 105.801C25.5125 105.028 25.9272 104.208 26.8642 103.347C27.8004 102.488 29.2093 101.635 31.07 100.808C34.7882 99.1561 40.1997 97.6563 46.9253 96.3924C60.3685 93.8662 78.9611 92.3005 99.5125 92.3005C120.064 92.3005 138.656 93.8662 152.1 96.3924C158.825 97.6563 164.237 99.1561 167.955 100.808C169.816 101.635 171.225 102.488 172.161 103.347C173.098 104.208 173.512 105.028 173.512 105.801C173.512 106.573 173.098 107.393 172.161 108.254C171.225 109.113 169.816 109.966 167.955 110.793C164.237 112.445 158.825 113.945 152.1 115.209C138.656 117.735 120.064 119.301 99.5125 119.301C78.9611 119.301 60.3685 117.735 46.9253 115.209C40.1997 113.945 34.7882 112.445 31.07 110.793C29.2093 109.966 27.8004 109.113 26.8642 108.254C25.9272 107.393 25.5125 106.573 25.5125 105.801Z\" fill=\"var(--dt-color-black-1000)\" stroke=\"url(#paint1_linear_14_817694)\"></path><mask id=\"mask0_14_817694\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"47\" y=\"44\" width=\"101\" height=\"67\"><rect x=\"47\" y=\"44\" width=\"100.115\" height=\"67\" fill=\"#D9D9D9\"></rect></mask><g mask=\"url(#mask0_14_817694)\"><rect x=\"65.4824\" y=\"52.4708\" width=\"69.3018\" height=\"121.663\" rx=\"34.6509\" stroke=\"url(#paint2_linear_14_817694)\" stroke-width=\"6.16016\"></rect><rect x=\"71.6421\" y=\"58.6311\" width=\"56.9815\" height=\"103.183\" rx=\"28.4907\" stroke=\"url(#paint3_linear_14_817694)\" stroke-width=\"6.16016\"></rect><rect x=\"77.8042\" y=\"64.7927\" width=\"44.6674\" height=\"86.2536\" rx=\"22.3337\" stroke=\"url(#paint4_linear_14_817694)\" stroke-width=\"6.16016\"></rect><rect x=\"83.9651\" y=\"70.9536\" width=\"32.3456\" height=\"70.8513\" rx=\"16.1728\" stroke=\"url(#paint5_linear_14_817694)\" stroke-width=\"6.16016\"></rect><rect x=\"88.0742\" y=\"76.6028\" width=\"24.1277\" height=\"71.8748\" rx=\"12.0639\" stroke=\"url(#paint6_linear_14_817694)\" stroke-width=\"5.13667\"></rect></g><circle cx=\"133.465\" cy=\"98.4648\" r=\"3.00179\" transform=\"rotate(-99.706 133.465 98.4648)\" fill=\"white\"></circle><circle cx=\"125.19\" cy=\"82.1898\" r=\"1.7397\" transform=\"rotate(-99.706 125.19 82.1898)\" stroke=\"black\" stroke-width=\"0.314862\"></circle><rect x=\"72.3284\" y=\"97.01\" width=\"3.29586\" height=\"3.29586\" transform=\"rotate(-54.4513 72.3284 97.01)\" stroke=\"black\" stroke-width=\"0.470837\"></rect><path d=\"M138.884 63V66.7667\" stroke=\"black\" stroke-width=\"0.224165\" stroke-miterlimit=\"10\"></path><path d=\"M137 64.8839H140.767\" stroke=\"black\" stroke-width=\"0.224165\" stroke-miterlimit=\"10\"></path><path d=\"M137.551 63.5511L140.215 66.2154\" stroke=\"black\" stroke-width=\"0.224165\" stroke-miterlimit=\"10\"></path><path d=\"M137.551 66.2154L140.215 63.5511\" stroke=\"black\" stroke-width=\"0.224165\" stroke-miterlimit=\"10\"></path><circle cx=\"110.598\" cy=\"65.5985\" r=\"4.13611\" transform=\"rotate(-118.159 110.598 65.5985)\" fill=\"white\"></circle><circle cx=\"70.465\" cy=\"48.4649\" r=\"3.00179\" transform=\"rotate(-99.706 70.465 48.4649)\" fill=\"black\"></circle><path d=\"M93.012 31V43.021\" stroke=\"black\" stroke-width=\"0.715402\" stroke-miterlimit=\"10\"></path><path d=\"M87 37.0122H99.021\" stroke=\"black\" stroke-width=\"0.715402\" stroke-miterlimit=\"10\"></path><path d=\"M88.759 32.7592L97.2619 41.262\" stroke=\"black\" stroke-width=\"0.715402\" stroke-miterlimit=\"10\"></path><path d=\"M88.759 41.262L97.2619 32.7592\" stroke=\"black\" stroke-width=\"0.715402\" stroke-miterlimit=\"10\"></path><path d=\"M82.4353 67V73.8692\" stroke=\"black\" stroke-width=\"0.408801\" stroke-miterlimit=\"10\"></path><path d=\"M79 70.4353H85.8692\" stroke=\"black\" stroke-width=\"0.408801\" stroke-miterlimit=\"10\"></path><path d=\"M80.0051 68.0051L84.8639 72.8639\" stroke=\"black\" stroke-width=\"0.408801\" stroke-miterlimit=\"10\"></path><path d=\"M80.0051 72.8639L84.8639 68.0051\" stroke=\"black\" stroke-width=\"0.408801\" stroke-miterlimit=\"10\"></path><rect x=\"50.7556\" y=\"79.9988\" width=\"3.7667\" height=\"3.7667\" transform=\"rotate(-36.5502 50.7556 79.9988)\" fill=\"var(--dt-color-black-1000)\"></rect><rect x=\"143\" y=\"85.0713\" width=\"1.79905\" height=\"1.79905\" transform=\"rotate(-36.5502 143 85.0713)\" fill=\"var(--dt-color-black-1000)\"></rect>", 22)),
		r("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M24.9999 105.801L173.862 105.801C173.24 140.686 140.154 168.801 99.4308 168.801C58.7073 168.801 25.6215 140.686 24.9999 105.801Z",
			fill: `url(#${e.uniqueID}paint7_linear_14_817694)`
		}, null, 8, l),
		t[15] || (t[15] = i("<path d=\"M25.5125 105.801C25.5125 105.028 25.9272 104.208 26.8642 103.347C27.8004 102.488 29.2093 101.635 31.07 100.808C34.7882 99.1561 40.1997 97.6563 46.9253 96.3924C60.3685 93.8662 78.9611 92.3005 99.5125 92.3005C120.064 92.3005 138.656 93.8662 152.1 96.3924C158.825 97.6563 164.237 99.1561 167.955 100.808C169.816 101.635 171.225 102.488 172.161 103.347C173.098 104.208 173.512 105.028 173.512 105.801C173.512 106.573 173.098 107.393 172.161 108.254C171.225 109.113 169.816 109.966 167.955 110.793C164.237 112.445 158.825 113.945 152.1 115.209C138.656 117.735 120.064 119.301 99.5125 119.301C78.9611 119.301 60.3685 117.735 46.9253 115.209C40.1997 113.945 34.7882 112.445 31.07 110.793C29.2093 109.966 27.8004 109.113 26.8642 108.254C25.9272 107.393 25.5125 106.573 25.5125 105.801Z\" fill=\"var(--dt-color-black-1000)\" stroke=\"url(#paint8_linear_14_817694)\"></path><mask id=\"mask1_14_817694\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"47\" y=\"44\" width=\"101\" height=\"67\"><rect x=\"47\" y=\"44\" width=\"100.115\" height=\"67\" fill=\"#D9D9D9\"></rect></mask><g mask=\"url(#mask1_14_817694)\"><rect x=\"65.4824\" y=\"52.4708\" width=\"69.3018\" height=\"121.663\" rx=\"34.6509\" stroke=\"url(#paint9_linear_14_817694)\" stroke-width=\"6.16016\"></rect><rect x=\"71.6421\" y=\"58.6311\" width=\"56.9815\" height=\"103.183\" rx=\"28.4907\" stroke=\"url(#paint10_linear_14_817694)\" stroke-width=\"6.16016\"></rect><rect x=\"77.8042\" y=\"64.7927\" width=\"44.6674\" height=\"86.2536\" rx=\"22.3337\" stroke=\"url(#paint11_linear_14_817694)\" stroke-width=\"6.16016\"></rect><rect x=\"83.9651\" y=\"70.9536\" width=\"32.3456\" height=\"70.8513\" rx=\"16.1728\" stroke=\"url(#paint12_linear_14_817694)\" stroke-width=\"6.16016\"></rect><rect x=\"88.0742\" y=\"76.6028\" width=\"24.1277\" height=\"71.8748\" rx=\"12.0639\" stroke=\"url(#paint13_linear_14_817694)\" stroke-width=\"5.13667\"></rect></g><circle cx=\"133.465\" cy=\"98.4648\" r=\"3.00179\" transform=\"rotate(-99.706 133.465 98.4648)\" fill=\"white\"></circle><circle cx=\"125.19\" cy=\"82.1898\" r=\"1.7397\" transform=\"rotate(-99.706 125.19 82.1898)\" stroke=\"black\" stroke-width=\"0.314862\"></circle><rect x=\"72.3284\" y=\"97.01\" width=\"3.29586\" height=\"3.29586\" transform=\"rotate(-54.4513 72.3284 97.01)\" stroke=\"black\" stroke-width=\"0.470837\"></rect><path d=\"M138.884 63V66.7667\" stroke=\"black\" stroke-width=\"0.224165\" stroke-miterlimit=\"10\"></path><path d=\"M137 64.8839H140.767\" stroke=\"black\" stroke-width=\"0.224165\" stroke-miterlimit=\"10\"></path><path d=\"M137.551 63.5511L140.215 66.2154\" stroke=\"black\" stroke-width=\"0.224165\" stroke-miterlimit=\"10\"></path><path d=\"M137.551 66.2154L140.215 63.5511\" stroke=\"black\" stroke-width=\"0.224165\" stroke-miterlimit=\"10\"></path><circle cx=\"110.598\" cy=\"65.5985\" r=\"4.13611\" transform=\"rotate(-118.159 110.598 65.5985)\" fill=\"white\"></circle><circle cx=\"70.465\" cy=\"48.4649\" r=\"3.00179\" transform=\"rotate(-99.706 70.465 48.4649)\" fill=\"black\"></circle><path d=\"M93.012 31V43.021\" stroke=\"black\" stroke-width=\"0.715402\" stroke-miterlimit=\"10\"></path><path d=\"M87 37.0122H99.021\" stroke=\"black\" stroke-width=\"0.715402\" stroke-miterlimit=\"10\"></path><path d=\"M88.759 32.7592L97.2619 41.262\" stroke=\"black\" stroke-width=\"0.715402\" stroke-miterlimit=\"10\"></path><path d=\"M88.759 41.262L97.2619 32.7592\" stroke=\"black\" stroke-width=\"0.715402\" stroke-miterlimit=\"10\"></path><path d=\"M82.4353 67V73.8692\" stroke=\"black\" stroke-width=\"0.408801\" stroke-miterlimit=\"10\"></path><path d=\"M79 70.4353H85.8692\" stroke=\"black\" stroke-width=\"0.408801\" stroke-miterlimit=\"10\"></path><path d=\"M80.0051 68.0051L84.8639 72.8639\" stroke=\"black\" stroke-width=\"0.408801\" stroke-miterlimit=\"10\"></path><path d=\"M80.0051 72.8639L84.8639 68.0051\" stroke=\"black\" stroke-width=\"0.408801\" stroke-miterlimit=\"10\"></path><rect x=\"50.7556\" y=\"79.9988\" width=\"3.7667\" height=\"3.7667\" transform=\"rotate(-36.5502 50.7556 79.9988)\" fill=\"var(--dt-color-black-1000)\"></rect><rect x=\"143\" y=\"85.0713\" width=\"1.79905\" height=\"1.79905\" transform=\"rotate(-36.5502 143 85.0713)\" fill=\"var(--dt-color-black-1000)\"></rect>", 22)),
		r("defs", null, [
			r("linearGradient", {
				id: `${e.uniqueID}paint0_linear_14_817694`,
				x1: "14.2075",
				y1: "101.706",
				x2: "58.5398",
				y2: "205.652",
				gradientUnits: "userSpaceOnUse"
			}, [...t[0] || (t[0] = [
				r("stop", { "stop-color": "#7C52FF" }, null, -1),
				r("stop", {
					offset: "0.33",
					"stop-color": "#FF13AC"
				}, null, -1),
				r("stop", {
					offset: "0.66",
					"stop-color": "#FF1356"
				}, null, -1),
				r("stop", {
					offset: "1",
					"stop-color": "#FF9E0E"
				}, null, -1)
			])], 8, u),
			r("linearGradient", {
				id: `${e.uniqueID}paint1_linear_14_817694`,
				x1: "27.6098",
				y1: "101.577",
				x2: "40.9792",
				y2: "169.336",
				gradientUnits: "userSpaceOnUse"
			}, [...t[1] || (t[1] = [
				r("stop", { "stop-color": "#7C52FF" }, null, -1),
				r("stop", {
					offset: "0.33",
					"stop-color": "#FF13AC"
				}, null, -1),
				r("stop", {
					offset: "0.66",
					"stop-color": "#FF1356"
				}, null, -1),
				r("stop", {
					offset: "1",
					"stop-color": "#FF9E0E"
				}, null, -1)
			])], 8, d),
			r("linearGradient", {
				id: `${e.uniqueID}paint2_linear_14_817694`,
				x1: "135.801",
				y1: "116.048",
				x2: "62.2493",
				y2: "102.435",
				gradientUnits: "userSpaceOnUse"
			}, [...t[2] || (t[2] = [
				r("stop", { "stop-color": "#7C52FF" }, null, -1),
				r("stop", {
					offset: "0.33",
					"stop-color": "#FF13AC"
				}, null, -1),
				r("stop", {
					offset: "0.66",
					"stop-color": "#FF1356"
				}, null, -1),
				r("stop", {
					offset: "1",
					"stop-color": "#FF9E0E"
				}, null, -1)
			])], 8, f),
			r("linearGradient", {
				id: `${e.uniqueID}paint3_linear_14_817694`,
				x1: "70.4116",
				y1: "111.969",
				x2: "83.0761",
				y2: "47.5329",
				gradientUnits: "userSpaceOnUse"
			}, [...t[3] || (t[3] = [
				r("stop", { "stop-color": "#7C52FF" }, null, -1),
				r("stop", {
					offset: "0.33",
					"stop-color": "#FF13AC"
				}, null, -1),
				r("stop", {
					offset: "0.66",
					"stop-color": "#FF1356"
				}, null, -1),
				r("stop", {
					offset: "1",
					"stop-color": "#FF9E0E"
				}, null, -1)
			])], 8, p),
			r("linearGradient", {
				id: `${e.uniqueID}paint4_linear_14_817694`,
				x1: "116.237",
				y1: "118.936",
				x2: "63.7872",
				y2: "96.7684",
				gradientUnits: "userSpaceOnUse"
			}, [...t[4] || (t[4] = [
				r("stop", { "stop-color": "#7C52FF" }, null, -1),
				r("stop", {
					offset: "0.33",
					"stop-color": "#FF13AC"
				}, null, -1),
				r("stop", {
					offset: "0.66",
					"stop-color": "#FF1356"
				}, null, -1),
				r("stop", {
					offset: "1",
					"stop-color": "#FF9E0E"
				}, null, -1)
			])], 8, m),
			r("linearGradient", {
				id: `${e.uniqueID}paint5_linear_14_817694`,
				x1: "69.6375",
				y1: "117.542",
				x2: "85.3926",
				y2: "59.2813",
				gradientUnits: "userSpaceOnUse"
			}, [...t[5] || (t[5] = [
				r("stop", { "stop-color": "#7C52FF" }, null, -1),
				r("stop", {
					offset: "0.33",
					"stop-color": "#FF13AC"
				}, null, -1),
				r("stop", {
					offset: "0.66",
					"stop-color": "#FF1356"
				}, null, -1),
				r("stop", {
					offset: "1",
					"stop-color": "#FF9E0E"
				}, null, -1)
			])], 8, h),
			r("linearGradient", {
				id: `${e.uniqueID}paint6_linear_14_817694`,
				x1: "115.773",
				y1: "111.504",
				x2: "81.9453",
				y2: "115.836",
				gradientUnits: "userSpaceOnUse"
			}, [...t[6] || (t[6] = [
				r("stop", { "stop-color": "#7C52FF" }, null, -1),
				r("stop", {
					offset: "0.33",
					"stop-color": "#FF13AC"
				}, null, -1),
				r("stop", {
					offset: "0.66",
					"stop-color": "#FF1356"
				}, null, -1),
				r("stop", {
					offset: "1",
					"stop-color": "#FF9E0E"
				}, null, -1)
			])], 8, g),
			r("linearGradient", {
				id: `${e.uniqueID}paint7_linear_14_817694`,
				x1: "14.2075",
				y1: "101.706",
				x2: "58.5398",
				y2: "205.652",
				gradientUnits: "userSpaceOnUse"
			}, [...t[7] || (t[7] = [
				r("stop", { "stop-color": "#7C52FF" }, null, -1),
				r("stop", {
					offset: "0.33",
					"stop-color": "#FF13AC"
				}, null, -1),
				r("stop", {
					offset: "0.66",
					"stop-color": "#FF1356"
				}, null, -1),
				r("stop", {
					offset: "1",
					"stop-color": "#FF9E0E"
				}, null, -1)
			])], 8, _),
			r("linearGradient", {
				id: `${e.uniqueID}paint8_linear_14_817694`,
				x1: "27.6098",
				y1: "101.577",
				x2: "40.9792",
				y2: "169.336",
				gradientUnits: "userSpaceOnUse"
			}, [...t[8] || (t[8] = [
				r("stop", { "stop-color": "#7C52FF" }, null, -1),
				r("stop", {
					offset: "0.33",
					"stop-color": "#FF13AC"
				}, null, -1),
				r("stop", {
					offset: "0.66",
					"stop-color": "#FF1356"
				}, null, -1),
				r("stop", {
					offset: "1",
					"stop-color": "#FF9E0E"
				}, null, -1)
			])], 8, v),
			r("linearGradient", {
				id: `${e.uniqueID}paint9_linear_14_817694`,
				x1: "135.801",
				y1: "116.048",
				x2: "62.2493",
				y2: "102.435",
				gradientUnits: "userSpaceOnUse"
			}, [...t[9] || (t[9] = [
				r("stop", { "stop-color": "#7C52FF" }, null, -1),
				r("stop", {
					offset: "0.33",
					"stop-color": "#FF13AC"
				}, null, -1),
				r("stop", {
					offset: "0.66",
					"stop-color": "#FF1356"
				}, null, -1),
				r("stop", {
					offset: "1",
					"stop-color": "#FF9E0E"
				}, null, -1)
			])], 8, y),
			r("linearGradient", {
				id: `${e.uniqueID}paint10_linear_14_817694`,
				x1: "70.4116",
				y1: "111.969",
				x2: "83.0761",
				y2: "47.5329",
				gradientUnits: "userSpaceOnUse"
			}, [...t[10] || (t[10] = [
				r("stop", { "stop-color": "#7C52FF" }, null, -1),
				r("stop", {
					offset: "0.33",
					"stop-color": "#FF13AC"
				}, null, -1),
				r("stop", {
					offset: "0.66",
					"stop-color": "#FF1356"
				}, null, -1),
				r("stop", {
					offset: "1",
					"stop-color": "#FF9E0E"
				}, null, -1)
			])], 8, b),
			r("linearGradient", {
				id: `${e.uniqueID}paint11_linear_14_817694`,
				x1: "116.237",
				y1: "118.936",
				x2: "63.7872",
				y2: "96.7684",
				gradientUnits: "userSpaceOnUse"
			}, [...t[11] || (t[11] = [
				r("stop", { "stop-color": "#7C52FF" }, null, -1),
				r("stop", {
					offset: "0.33",
					"stop-color": "#FF13AC"
				}, null, -1),
				r("stop", {
					offset: "0.66",
					"stop-color": "#FF1356"
				}, null, -1),
				r("stop", {
					offset: "1",
					"stop-color": "#FF9E0E"
				}, null, -1)
			])], 8, x),
			r("linearGradient", {
				id: `${e.uniqueID}paint12_linear_14_817694`,
				x1: "69.6375",
				y1: "117.542",
				x2: "85.3926",
				y2: "59.2813",
				gradientUnits: "userSpaceOnUse"
			}, [...t[12] || (t[12] = [
				r("stop", { "stop-color": "#7C52FF" }, null, -1),
				r("stop", {
					offset: "0.33",
					"stop-color": "#FF13AC"
				}, null, -1),
				r("stop", {
					offset: "0.66",
					"stop-color": "#FF1356"
				}, null, -1),
				r("stop", {
					offset: "1",
					"stop-color": "#FF9E0E"
				}, null, -1)
			])], 8, S),
			r("linearGradient", {
				id: `${e.uniqueID}paint13_linear_14_817694`,
				x1: "115.773",
				y1: "111.504",
				x2: "81.9453",
				y2: "115.836",
				gradientUnits: "userSpaceOnUse"
			}, [...t[13] || (t[13] = [
				r("stop", { "stop-color": "#7C52FF" }, null, -1),
				r("stop", {
					offset: "0.33",
					"stop-color": "#FF13AC"
				}, null, -1),
				r("stop", {
					offset: "0.66",
					"stop-color": "#FF1356"
				}, null, -1),
				r("stop", {
					offset: "1",
					"stop-color": "#FF9E0E"
				}, null, -1)
			])], 8, C)
		])
	], 8, s);
}
var T = /* @__PURE__ */ t(o, [["render", w]]);
//#endregion
export { T as default };

//# sourceMappingURL=mind.js.map